import { DocumentOrFolderOrigin } from './documentOrFolderOrigin'

export enum CreateFolderActionOriginType {
  CPA = DocumentOrFolderOrigin.CPA,
  BO = DocumentOrFolderOrigin.BO,
}
